import React, { useState, useEffect } from 'react';
import './Summary.css';
import { summaryAPI } from '../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faBug } from '@fortawesome/free-solid-svg-icons';

export default function SummaryWidget({ dateRange }) {
  const [kpis, setKpis] = useState({
    devicesInstalled: 0,
    totalInsects: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchKPIs() {
      try {
        setLoading(true);
        const response = await summaryAPI.getKPIs(dateRange);
        setKpis(response.data);
      } catch (error) {
        console.error('Failed to fetch KPIs:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchKPIs();
  }, [dateRange]);

  if (loading) {
    return <div className="sum-widgets">Loading...</div>;
  }

  return (
    <div className="sum-widgets">
      <div className="widget">
        <div className="widget-icon"><FontAwesomeIcon icon={faLocationDot} /></div>
        <div>
          <div className="widget-value">{kpis.devicesInstalled.toLocaleString('en-US')}</div>
          <div className="widget-label">Total Devices Installed</div>
        </div>
      </div>

      <div className="widget">
        <div className="widget-icon bug"><FontAwesomeIcon icon={faBug} /></div>
        <div>
          <div className="widget-value">{kpis.totalInsects.toLocaleString('en-US')}</div>
          <div className="widget-label">Total Insects Trapped</div>
        </div>
      </div>
    </div>
  );
}